export const state = {
    userInfo: null,
    userData: {},
    hasAnyApiLicense: false,
    userIsBrkAuthorized: false,
    userIsNedBrkAuthorized: false,
    userIsBrpAuthorized: false,
    userIsWozAuthorized: false,
    userIsStufAuthorized: false,
    userIsAllowedStufPersonQueries: false,
    userIsKvkAuthorized: false,
    userIsEnergyLabelAuthorized: false,
    userWozApiId: null,
    userWozApiData: {}
};

export default state;
